import { QueryKey } from '@/configs/queryKeys';
import { Attribute } from './AttributeApi';
import { Attachment, CreatorAction, Translations, UUID } from '@/types/types';
import { PriceGroup } from './PriceGroupApi';
import EntityApi, { BaseEntity } from './EntityApi';
import { QueryFunctionContext } from '@tanstack/react-query';
import httpClient from './httpClient';

export enum RelationTypeEnum {
	ATTRIBUTE_VALUE = 'attributeValue',
}

export enum RelationActions {
	HIDE = 'hide',
	SHOW = 'show',
}

export enum LogicalOperator {
	AND = 'and',
	OR = 'or',
}

export interface RelationCondition {
	type: RelationTypeEnum;
	objectId?: UUID;
}

export interface Relation {
	action: RelationActions;
	operator: LogicalOperator;
	conditions: RelationCondition[];
}

export interface AttributeValueRelatedValue {
	attributeValueId: UUID;
	attributeId: UUID;
}

export interface IntermediaryAttributeValue extends BaseEntity {
	value: AttributeValue;
	price: number;
}

export interface AttributeValue extends BaseEntity {
	value: string;
	displayName: string;
	attribute: Attribute;
	description: string;
	shopUrl: string;
	listOrder: number;
	image: Attachment;
	price: number;
	priceGroup?: PriceGroup;
	actions: CreatorAction[];
	relation?: Relation;
	relatedValue?: AttributeValueRelatedValue;
	translations: Translations<{
		displayName: string;
		description: string;
	}>;
}

class AttributeValueApi extends EntityApi<AttributeValue> {
	constructor() {
		super(QueryKey.attributeValues);
		this.mutationFindByIds = this.mutationFindByIds.bind(this);
	}

	async findByIds({ queryKey }: QueryFunctionContext<[QueryKey, UUID[]]>) {
		const response = await httpClient.post<AttributeValue[]>(
			`${queryKey[0]}/by-ids`,
			{
				ids: queryKey[1],
			}
		);

		return response.data;
	}

	async mutationFindByIds(ids: UUID[]) {
		const response = await httpClient.post<AttributeValue[]>(
			`${this.queryKey}/by-ids`,
			{
				ids,
			}
		);

		return response.data;
	}
}

export default new AttributeValueApi();
